/**
 * All the Functionalities Related to Reports
 * Module is included here
 */
import * as TeamMemberPerformanceTemplate from 'raw-loader!src/app/public/app/partials/missioncontrol/reports/teammembersperformance/teammemberperformance.html';
var teammemberperformancemodule = angular.module('4dot5.missioncontrolmodule.reportsmodule.teammemberperformancemodule', ['4dot5.missioncontrolmodule.reportsmodule.teammemberperformancemodule.performancebyteammembermodule',
    '4dot5.missioncontrolmodule.reportsmodule.teammemberperformancemodule.performancebymeasuresmodule'
]);
teammemberperformancemodule.constant('TEAMMEMBERPERFORMANCECONSTANTS', {
    CONFIG: {
        STATE: 'missioncontrol.reports.teammembersperformance',
        URL: '/teammembersperformance',
        CONTROLLER: 'TeamMemberPerformanceController',
        TEMPLATE: TeamMemberPerformanceTemplate.default,
    }
});
teammemberperformancemodule.config(['$stateProvider',
    'TEAMMEMBERPERFORMANCECONSTANTS',
    function ($stateProvider, TEAMMEMBERPERFORMANCECONSTANTS) {
        $stateProvider.state(TEAMMEMBERPERFORMANCECONSTANTS.CONFIG.STATE, {
            url: TEAMMEMBERPERFORMANCECONSTANTS.CONFIG.URL,
            template: TEAMMEMBERPERFORMANCECONSTANTS.CONFIG.TEMPLATE,
            controller: TEAMMEMBERPERFORMANCECONSTANTS.CONFIG.CONTROLLER,
            data: {
                requireLogin: true
            },
            params: {
                reportType: null
            }
        });
    }
]);
teammemberperformancemodule.controller('TeamMemberPerformanceController', ['$scope',
    '$state',
    '$window',
    '$location',
    '$stateParams',
    '$rootScope',
    '$http',
    'StorageService',
    'genericService',
    'TEAMMEMBERPERFORMANCECONSTANTS',
    function ($scope, $state, $window, $location, $stateParams, $rootScope, $http, StorageService, genericService, TEAMMEMBERPERFORMANCECONSTANTS) {
        console.log('TeamMemberPerformanceController');
    }
]);
//# sourceMappingURL=teammemberperformance.js.map